import { useCallback } from 'react'

import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import { actionsSelector, useStoreApi } from '@liveHelper/models/store'
import { useTrackClickScheduleLinkOut } from '@liveHelper/tracking/useLiveHelperTracking'

/**
 * Hook to start scheduling. Opens Calendly integration or scheduling url in a new tab.
 */
export const useStartScheduling = () => {
  const chatChannelConfig = useChatChannelConfig()
  const trackClickScheduleLinkOut = useTrackClickScheduleLinkOut()
  const storeApi = useStoreApi()

  return useCallback(() => {
    if (
      chatChannelConfig?.config?.scheduling_provider ===
      'SCHEDULING_PROVIDER_NONE'
    ) {
      return
    }
    if (
      chatChannelConfig?.config?.scheduling_provider ===
      'SCHEDULING_PROVIDER_CALENDLY'
    ) {
      const actions = actionsSelector(storeApi.getState())
      actions.sendUIStateTransitionEvent('START_SCHEDULING')
    } else if (
      chatChannelConfig?.config?.scheduling_provider ===
        'SCHEDULING_PROVIDER_LANDING_PAGE' &&
      chatChannelConfig?.config.scheduling_url
    ) {
      window.open(chatChannelConfig.config.scheduling_url, '_blank')
    }
    trackClickScheduleLinkOut()
  }, [chatChannelConfig, trackClickScheduleLinkOut, storeApi])
}
